import React, { useEffect, useState } from "react";
import axiosConfig from "../../Service/axiosConfig";
import { MdDeleteOutline } from "react-icons/md";
import DataTable from "react-data-table-component";
import { DeletePopupModal, PopupModal } from "../../Components";
import AlertDeletePopupModal from "../../Components/PopupModal/AlertDeletePopupModal";
import "../../Pages/master_categories.css";
import {
  MdKeyboardArrowUp,
  MdKeyboardArrowDown,
  MdDelete,
} from "react-icons/md";
import { FiSave } from "react-icons/fi";
import { FileManager } from "../../Components/FileManager";
import Select from "react-select";
import { FaHandHoldingHeart } from "react-icons/fa";
import tableCustomStyles from "../PopupModal/tableCustomStyles";
const ProductSection = ({
  id,
  selectedhomepageId,
  productSecId,
  is_suspended,
  getTemplate
}) => {
  const [AlertDeletePopupType, SetAlertDeletePopupType] = useState("");
  const [deletePopupType, setDeletepopupType] = useState("");
  const [loading, setLoading] = useState(false);
  const [RowId, SetRowId] = useState();
  const [RowPerPage, setRowPerPage] = useState(20);
  const [selectedRows, setSelectedRows] = useState([]);
  const [Error, SetError] = useState();
  const [popupType, setpopupType] = useState("");
  const [sortedBanners, setSortedBanners] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [search, SetSearch] = useState({
    search: "",
  });
  const [Data, SetData] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [modalShow, setModalShow] = useState(false);
  const [Message, SetMessage] = useState("");
  const [subcategoryOptions, setSubcategoryOptions] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [formData, setFormData] = useState({});

  const fetchSubcategories = async () => {
    setLoading(true);
    try {
      const response = await axiosConfig.get(
        `/catlog/displaycategories/?page_size=150&is_suspended=false`
      );
      setSubcategoryOptions(
        response.data.results.map((item) => ({
          value: item?.id,
          label: item?.subcategory?.name || item?.promotional_category?.title,
        }))
      );
    } catch (error) {
      console.error("Error fetching products:", error);
      setSubcategoryOptions([]);
    }
  };

  useEffect(() => {
    fetchSubcategories();
  }, []);
  useEffect(() => {
    if (productSecId) {
      GetData(productSecId);
    }
  }, [productSecId]);
  console.log(productSecId, "subcategoryOptions");
  const GetData = async (sectionId = productSecId) => {
    setLoading(true);
    try {
      const response = await axiosConfig.get(
        `/cms/get_homepagedesign/?section_id=${sectionId}`
      );

      const flattenedProducts = response.data.results.flatMap((section) =>
        section.subcategory.map((subcategory) => ({
          ...subcategory,
          section_id: section.id,
          section_title: section.title,
        }))
      );
      SetData(flattenedProducts);
      setLoading(false);
      setTotalRows(flattenedProducts.length);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };



  console.log(Data, "kljm");
  const handleProductChange = (selectedOptions) => {
    setSelectedProducts(selectedOptions);
  };
  const handleImageChange = (files) => {
    const file = files[0].image;
    const file_key = files[0].id;
    setSelectedImage(file);
    setFormData({ ...formData, ["image"]: file_key });
  };

  const handleSort = (column, direction, newOrder) => {
    setSortedBanners(newOrder);
    axiosConfig
      .get(
        `/catlog/displaycategories/?ordering=${direction === "asc" ? column.selector : -column.selector
        }`
      )
      .then((res) => {
        SetData(res.data.results);
      })
      .catch((error) => {
        console.log(error);
      });
    setCurrentPage(1);
  };
  const handleRowSelected = ({ selectedRows }) => {
    setSelectedRows(selectedRows);
  };

  const handleSaveSelected = async () => {
    if (selectedProducts.length === 0) {
      return;
    }

    const selectedIds = selectedProducts.map((product) => product.value);

    try {
      console.log(productSecId, "vvvvv");
      if (productSecId) {
        await axiosConfig.post(
          `/cms/homepage_template/${productSecId}/add_items/`,
          {
            item_type: "subcategory",
            item_ids: selectedIds,
          }
        );
        await GetData(productSecId);
        SetMessage("Product Template updated successfully");
        setpopupType("success");
      } else {
        await axiosConfig.post("/cms/homepage_template/", {
          home_page: selectedhomepageId,
          title: "Products",
          subcategory: selectedIds,
          sort: id,
        });
      }

      // GetData();
      await getTemplate()
      SetMessage("Product Template created successfully");
      setpopupType("success");
    } catch (error) {
      SetError("Error saving template");
      setpopupType("error");
      console.error("Error saving Product template:", error);
    }
  };

  const columns = [
    {
      name: "S.No",
      selector: "id",
      cell: (row, i) => (currentPage - 1) * RowPerPage + i + 1,
      sortable: true,
    },
    {
      name: "Subcategory Name",
      selector: "name",
      cell: (row) => row.name,
      sortable: true,
    },

    {
      name: "Status",
      selector: "status",
      cell: (row) => (row.status ? "Active" : "InActive"),
    },
    {
      name: "Order By",
      selector: "orderby",
      sortable: true,
    },
    {
      name: "Section Title",
      selector: "section_title",
      cell: (row) => row.section_title,
      sortable: true,
    },
    {
      name: "Section ID",
      selector: "section_id",
      cell: (row) => row.section_id,
      sortable: true,
    },
    {
      name: "ACTIONS",
      width: "150px",
      selector: (row) => {
        const DeleteAlert = () => {
          SetRowId(row.id);
          SetAlertDeletePopupType("success");
        };
        const CancelAlerrt = () => {
          SetAlertDeletePopupType("error");
        };

        const HandleDelete = async (id) => {
          try {
            if (productSecId) {
              await axiosConfig.post(
                `/cms/homepage_template/${productSecId}/remove_items/`,
                {
                  item_type: "subcategory",
                  item_ids: id,
                }
              );
            }

            SetAlertDeletePopupType("error");
            setDeletepopupType("success");
            await GetData();
            setTimeout(() => {
              getTemplate()
            }, 300);
          } catch (error) {
            setDeletepopupType("error");
            SetAlertDeletePopupType("error");
            console.error("Error deleting banner:", error);
          }
        };

        return (
          <>
            {!row.is_suspended ? (
              <div className="row">
                <div className="table-actions">
                  <button className="action-btn delete-btn" onClick={DeleteAlert}>
                    <MdDeleteOutline /> Delete
                  </button>
                </div>
              </div>
            ) : null}
            {AlertDeletePopupType === "success" && (
              <AlertDeletePopupModal
                AlertDeletePopupType={AlertDeletePopupType}
                HandleDelete={HandleDelete}
                CancelAlerrt={CancelAlerrt}
                row={RowId}
              />
            )}
          </>
        );
      },
    },
  ];
  const SectionDelete = async () => {
    try {
      await axiosConfig.delete(`/cms/homepage_template/${productSecId}/`);
      SetMessage("Product template deleted successfully");
      setpopupType("success");
      // GetData();
      await getTemplate();
    } catch (error) {
      SetError("Error deleting Product template");
      setpopupType("error");
      console.error(error);
    }
  };
  const handleReviveSection = async () => {
    try {
      const response = await axiosConfig.post(
        `/cms/homepage_template/${productSecId}/revive/`
      );
      setpopupType("success");
      SetMessage("product section revived successfully");
      await GetData();
      await getTemplate();
    } catch (error) {
      SetError("Error while reviving product section");
      setpopupType("error");
      console.error("Revival error:", error);
    }
  };

  return (
    <>
      <div className="child-sidenav">
        <div className="childnav-content">
          <div className="text-block-end border-remove">
            <div className="text-block-border">
              <h5 className="dashboard-subtitle">Product Section</h5>

              <div className="d-flex gap-4">
                {!is_suspended ? (
                  <>
                    <MdKeyboardArrowUp />
                    <MdKeyboardArrowDown />
                    <FiSave
                      size={24}
                      onClick={handleSaveSelected}
                      style={{ cursor: "pointer" }}
                    />
                    <MdDelete
                      style={{ cursor: "pointer" }}
                      size={24}
                      onClick={SectionDelete}
                    />
                  </>
                ) : (
                  <FaHandHoldingHeart
                    size={24}
                    onClick={handleReviveSection}
                    style={{ cursor: "pointer", color: "green" }}
                  />
                )}
              </div>
            </div>

            <div className="col-md-4 sub-filter mt-3">
              <Select
                options={subcategoryOptions}
                placeholder="Select subcategory"
                isMulti={true}
                onChange={handleProductChange}
                value={selectedProducts}
              />
            </div>

            <div className="p-2">
              <div className="table-responsive">
                <DataTable
                  columns={columns}
                  data={Data}
                  pagination
                  paginationTotalRows={totalRows}
                  paginationPerPage={RowPerPage}
                  onSelectedRowsChange={handleRowSelected}
                  draggableColumns
                  paginationDefaultPage={currentPage}
                  customStyles={tableCustomStyles}
                  onChangePage={(page) => setCurrentPage(page)}
                  paginationPerPageOptions={[10, 20, 25, 30, 40, 50]}
                  paginationRowsPerPageOptions={[10, 20, 25, 30, 40, 50]}
                  onChangeRowsPerPage={(RowsPerPageChange) =>
                    setRowPerPage(RowsPerPageChange)
                  }
                  onSort={handleSort}
                  progressPending={loading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {popupType && (
        <PopupModal
          popupType={popupType}
          setpopupType={setpopupType}
          Message={Message}
          error={Error}
        />
      )}
      {deletePopupType && (
        <DeletePopupModal
          setDeletepopupType={setDeletepopupType}
          deletePopupType={deletePopupType}
        />
      )}
      {modalShow && (
        <FileManager
          modalShow={modalShow}
          setModalShow={setModalShow}
          handleFile={handleImageChange}
          ismultiple={false}
          value="image_key"
        />
      )}
    </>
  );
};

export { ProductSection };
